module.exports = __webpack_public_path__ + "static/Logo-01-7ab7913397bd1d034eb1f64758306adf.png";